import { render, staticRenderFns } from "./TextOrRule.vue?vue&type=template&id=45a9a52e&scoped=true"
import script from "./TextOrRule.vue?vue&type=script&lang=js"
export * from "./TextOrRule.vue?vue&type=script&lang=js"
import style0 from "./TextOrRule.vue?vue&type=style&index=0&id=45a9a52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a9a52e",
  null
  
)

export default component.exports